import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgWashFaceGlyphSecondary from './svgs/WashFaceGlyphSecondary.js';
import { useIcon } from '../../shared-components/icon/index.js';

var washFaceGlyph = (props => useIcon(null, SvgWashFaceGlyphSecondary, props));

export { washFaceGlyph as default };
